import React, { Component, PropTypes } from 'react';
import Dropdown from 'common/components/Dropdown';

export class ContactSelectorItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    //this._onChange = this._onChange.bind(this);
  }

  componentWillMount() {
    if (!this.props.value && this.props.site.contact_id) {
      this.props.onChange(
        this.props.site.contact_id,
        this.props.site.contact_id
      );
    }
  }

  render() {
    const { site, contacts, value, onChange, error } = this.props;

    //const onCheckboxChange = val => onChange(site, value);
    const renderDefault = () => (
      <div className="default text">Choisissez un contact</div>
    );

    const renderContact = contact => (
      <div key={contact.id} data-value={contact.id} className="item">
        {contact.last_name} {contact.first_name}
      </div>
    );

    const valueWithDefault = () => {
      if (value) return value;
      else if (site.contact_id) return site.contact_id;
      else return undefined;
    };

    const filteredContact = () => {
      return contacts.filter(
        c =>
          c.is_usable_as_contact_site === true &&
          (c.is_deleted === false || c.id === value)
      );
    };

    return (
      <div className="fields">
        <div className="two wide field" style={{ paddingTop: '7px' }}>
          <a>{site.name}</a>
        </div>
        <div className="six wide field">
          <Dropdown
            name={`contact_${site.id}`}
            value={valueWithDefault()}
            items={filteredContact()}
            renderDefault={renderDefault}
            renderItem={renderContact}
            onChange={onChange}
          />
        </div>
      </div>
    );
  }
}

ContactSelectorItem.propTypes = {
  site: PropTypes.object.isRequired,
  contacts: PropTypes.array.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
};

export default ContactSelectorItem;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/components/ContactSelectorItem.js